@if (!isDismissed()) {
  <neo-card [class]="cardClasses()">
    @if (collapsible()) {
      <neo-card-header
        class="collapsible-header"
        [class.collapsible-header--expanded]="expanded()"
      >
        <cm-icon neo-card-avatar mode="outline" [name]="icon()" [size]="iconSize()" />
        <h2 neo-card-title [attr.id]="headingId">
          <button
            type="button"
            class="collapsible-header__toggle"
            [attr.aria-expanded]="expanded()"
            [attr.aria-controls]="expanded() ? contentId : null"
            [attr.aut-id]="'alert-card-toggle'"
            (click)="toggleExpanded()"
          >
            <strong>{{ title() }}</strong>
          </button>
        </h2>
        <cm-icon
          class="expand-icon"
          [name]="expanded() ? 'expand_less' : 'expand_more'"
          aria-hidden="true"
        />
        @if (dismissible()) {
          <cm-action-button
            class="dismiss-button"
            iconName="close"
            iconSize="md"
            size="sm"
            [color]="color()"
            [ariaLabel]="dismissLabel()"
            [title]="dismissLabel()"
            autId="alert-card-dismiss"
            (click)="onDismiss($event)"
          />
        }
      </neo-card-header>
    } @else {
      <neo-card-header>
        <cm-icon neo-card-avatar mode="outline" [name]="icon()" [size]="iconSize()" />
        <h2 neo-card-title>
          <strong>{{ title() }}</strong>
        </h2>
        @if (subtitle()) {
          <neo-card-subtitle>
            {{ subtitle() }}
          </neo-card-subtitle>
        }
        @if (dismissible()) {
          <cm-action-button
            class="dismiss-button"
            iconName="close"
            iconSize="md"
            size="sm"
            [color]="color()"
            [ariaLabel]="dismissLabel()"
            [title]="dismissLabel()"
            autId="alert-card-dismiss"
            (click)="onDismiss($event)"
          />
        }
      </neo-card-header>
    }
    <div
      class="alert-content"
      [class.collapsible-content]="collapsible()"
      [hidden]="collapsible() && !expanded()"
      [attr.id]="collapsible() ? contentId : null"
      [attr.role]="collapsible() ? 'region' : null"
      [attr.aria-labelledby]="collapsible() ? headingId : null"
    >
      <ng-content />
    </div>
  </neo-card>
}
